import Brady from '@assets/brady.jpg';
import React from 'react';
import styled from 'styled-components';
import { JoinPrimary } from '../../../components-legacy/Buttons/JoinNow';
import { H1, P } from '../../../components/Typography/Typography';
import { media } from '../../../components/style-utils';
import { EnrollmentEndsAt } from '@Constants';

export const SectionHero = function() {
  let labelText = 'Enrollment closing soon';
  if (EnrollmentEndsAt < new Date()) {
    labelText = 'Class is full - click here to join the waitlist';
  }

  return (
    <Container>
      <Image src={Brady} />
      <TextBox>
        <H1>12-Week Social Media Mentorship with Brady Shearer</H1>
        <StyledP>
          Discover the 6-part process for using social media to help accomplish your church’s biggest goals.
        </StyledP>
        <JoinButton href="#pricing" />
        <Label>{labelText}</Label>
      </TextBox>
    </Container>
  );
};

const Container = styled.section`
  margin: 0;

  position: relative;
  width: 100vw;
`;

const JoinButton = styled(JoinPrimary)`
  margin-top: 3.3rem;
`;

const Image = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center top;

  ${media.desktopAndUp`
    background-position-x: -10rem;
  `}
`;

const Label = styled.div`
  font-size: 17px;
  letter-spacing: -0.51px;
  line-height: 30px;

  ${media.desktopAndUp`
    max-width: 32rem;
    text-align: center;
  `}
`;

const StyledP = styled(P)``;

const TextBox = styled.div`
  position: relative;
  z-index: 2;

  margin-left: auto;
  margin-right: auto;
  max-width: 40rem;
  padding: 20rem 5rem 5rem;

  color: var(--colorWhite);
  text-align: center;

  ${media.tabletPortraitAndUp`
    max-width: 85rem;
    padding-top: 25rem;
    padding-bottom: 10rem;
  `}

  ${media.desktopAndUp`
    text-align: left;
    transform: translateX(15vw);
  `}
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionHero.js